import { getApiBaseUrl } from "../config/api";

const BASE = getApiBaseUrl();

export type Update = {
  id: string;
  title: string;
  slug: string;
  published_at: string;
  body_html: string;
  created_at: string;
};

export type UpdateMedia = {
  id: string;
  update_id: string;
  type: string;
  url: string;
  name: string;
  sort_order: number;
};

export type UpdateWithMedia = Update & {
  media: UpdateMedia[];
};

export const getUpdates = (): Promise<Update[]> =>
  fetch(`${BASE}/public_updates`).then((r) => {
    if (!r.ok) throw new Error(String(r.status));
    return r.json();
  });

export const getUpdate = (idOrSlug: string): Promise<UpdateWithMedia> =>
  fetch(`${BASE}/public_updates/${encodeURIComponent(idOrSlug)}`).then((r) => {
    if (!r.ok) throw new Error(String(r.status));
    return r.json();
  });
